// constants/steps.js
import i18n from '../i18n'; // Adjust path according to your i18n setup

export const getSteps = () => [
  i18n.t('dvaCreditClaims.steps.dvaDetails'),
  i18n.t('dvaCreditClaims.steps.cardDetails'),
  i18n.t('dvaCreditClaims.steps.itemDetails'),
  i18n.t('dvaCreditClaims.steps.printSign'),
  i18n.t('dvaCreditClaims.steps.confirmation'),
];

export const getPartnerLocationOptions = () => [
  {
    title: i18n.t('dvaCreditClaims.partnerLocation.options.placeOfDreams'),
    value: 'place_of_dreams',
  },
  {
    title: i18n.t('dvaCreditClaims.partnerLocation.options.cityHospital'),
    value: 'city_hospital',
  },
  {
    title: i18n.t('dvaCreditClaims.partnerLocation.options.greenValley'),
    value: 'green_valley',
  },
  {
    title: i18n.t('dvaCreditClaims.partnerLocation.options.sunriseHealthcare'),
    value: 'sunrise_healthcare',
  },
];

export const getSelectOptions = () => [
  {
    value: i18n.t('dvaCreditClaims.partnerLocation.options.placeOfDreams'),
    title: i18n.t('dvaCreditClaims.partnerLocation.options.placeOfDreams'),
  },
  {
    value: i18n.t('dvaCreditClaims.partnerLocation.options.cityMedicalCenter'),
    title: i18n.t('dvaCreditClaims.partnerLocation.options.cityMedicalCenter'),
  },
  {
    value: i18n.t('dvaCreditClaims.partnerLocation.options.regionalHealthClinic'),
    title: i18n.t('dvaCreditClaims.partnerLocation.options.regionalHealthClinic'),
  },
];

export const getMultipleChoiceQuestions = () => ({
  1: {
    question: i18n.t('dvaCreditClaims.multipleChoice.claimType.question'),
    field: 'claimType',
    options: [
      {
        value: 'medical',
        label: i18n.t('dvaCreditClaims.multipleChoice.claimType.options.medical'),
      },
      {
        value: 'pharmaceutical',
        label: i18n.t('dvaCreditClaims.multipleChoice.claimType.options.pharmaceutical'),
      },
      {
        value: 'consultation',
        label: i18n.t('dvaCreditClaims.multipleChoice.claimType.options.consultation'),
      },
      {
        value: 'therapy',
        label: i18n.t('dvaCreditClaims.multipleChoice.claimType.options.therapy'),
      },
    ],
  },
  2: {
    question: i18n.t('dvaCreditClaims.multipleChoice.urgencyLevel.question'),
    field: 'urgencyLevel',
    options: [
      {
        value: 'immediate',
        label: i18n.t('dvaCreditClaims.multipleChoice.urgencyLevel.options.immediate'),
      },
      {
        value: 'urgent',
        label: i18n.t('dvaCreditClaims.multipleChoice.urgencyLevel.options.urgent'),
      },
      {
        value: 'standard',
        label: i18n.t('dvaCreditClaims.multipleChoice.urgencyLevel.options.standard'),
      },
      {
        value: 'routine',
        label: i18n.t('dvaCreditClaims.multipleChoice.urgencyLevel.options.routine'),
      },
    ],
  },
  3: {
    question: i18n.t('dvaCreditClaims.multipleChoice.documentType.question'),
    field: 'documentType',
    options: [
      {
        value: 'prescription',
        label: i18n.t('dvaCreditClaims.multipleChoice.documentType.options.prescription'),
      },
      {
        value: 'referral',
        label: i18n.t('dvaCreditClaims.multipleChoice.documentType.options.referral'),
      },
      {
        value: 'assessment',
        label: i18n.t('dvaCreditClaims.multipleChoice.documentType.options.assessment'),
      },
      {
        value: 'report',
        label: i18n.t('dvaCreditClaims.multipleChoice.documentType.options.report'),
      },
    ],
  },
  4: {
    question: i18n.t('dvaCreditClaims.multipleChoice.confirmationMethod.question'),
    field: 'confirmationMethod',
    options: [
      {
        value: 'email',
        label: i18n.t('dvaCreditClaims.multipleChoice.confirmationMethod.options.email'),
      },
      {
        value: 'sms',
        label: i18n.t('dvaCreditClaims.multipleChoice.confirmationMethod.options.sms'),
      },
      {
        value: 'mail',
        label: i18n.t('dvaCreditClaims.multipleChoice.confirmationMethod.options.mail'),
      },
      {
        value: 'phone',
        label: i18n.t('dvaCreditClaims.multipleChoice.confirmationMethod.options.phone'),
      },
    ],
  },
});

export const getInitialFormData = () => ({
  requiredData: {
    customerDefaultPrice: '',
    invoiceDuePrice: '',
  },
  dvaDetails: {
    partnerLocationUUIDPK: '',
    cardType: '',
    approvalNumber: '',
    dateSupplied: null,
  },
  cardDetails: {
    dvaFileNumber: '',
    firstName: '',
    surname: '',
    phoneNumber: '',
    gender: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    state: '',
    postcode: '',
  },
  itemDetails: [{
    itemNumber: '',
    itemDescription: '',
    lotSerial: '',
    quantity: '',
    isValid: false,
  }],
  confirmationDetials: {
    pdfUrl: '',
    dvaOrderNumber: '',
  },
  claimDetails: {
    claimType: '',
    urgencyLevel: '',
    documentType: '',
    confirmationMethod: '',
  },
});

export const AUSTRALIAN_STATES = [
  { value: 'NSW', title: 'New South Wales' },
  { value: 'VIC', title: 'Victoria' },
  { value: 'QLD', title: 'Queensland' },
  { value: 'WA', title: 'Western Australia' },
  { value: 'SA', title: 'South Australia' },
  { value: 'TAS', title: 'Tasmania' },
  { value: 'ACT', title: 'Australian Capital Territory' },
  { value: 'NT', title: 'Northern Territory' },
];

export const FORM_FIELDS = [
  { name: 'dvaFileNumber', key: 'dvafilenumber', required: true, cols: 12, type: 'text' },
  { name: 'firstName', key: 'firstinitial', required: true, cols: { xs: 12, sm: 6 }, type: 'text', maxLength: 1 },
  { name: 'surname', key: 'surname', required: true, cols: { xs: 12, sm: 6 }, type: 'text' },
  { name: 'phoneNumber', key: 'phonenumber', required: true, cols: 12, type: 'phone' },
  { name: 'addressLine1', key: 'addressline1', required: true, cols: 12, type: 'text' },
  { name: 'addressLine2', key: 'addressline2', required: false, cols: { xs: 12, sm: 6 }, type: 'text' },
  { name: 'addressLine3', key: 'addressline3', required: false, cols: { xs: 12, sm: 6 }, type: 'text' },
  { name: 'townCity', key: 'towncity', required: true, cols: { xs: 12, sm: 4 }, type: 'text' },
  { name: 'state', key: 'state', required: true, cols: { xs: 12, sm: 4 }, type: 'dropdown' }, // Changed to dropdown
  { name: 'postcode', key: 'postcode', required: true, cols: { xs: 12, sm: 4 }, type: 'number', maxLength: 4 },
];

export const GENDER_OPTIONS = [
  { value: "M", label: "male" },
  { value: "F", label: "female" },
  { value: "O", label: "other" },
];


export const mockCatalogItems = [
  { itemNumber: '64223', description: 'AirFit™ N30 Mask - Medium', type: 'Good', maxQuantity: 10 },
  { itemNumber: '64224', description: 'AirFit™ N30 Mask - Small-Wide', type: 'Good', maxQuantity: 8 },
  { itemNumber: '64201', description: 'AirFit™ N30 Mask Starter Pack', type: 'Good', maxQuantity: 5 },
  { itemNumber: '64101', description: 'AirFit™ F30 Complete Mask - Medium', type: 'Good', maxQuantity: 12 },
  { itemNumber: '64222', description: 'AirFit™ N30 Mask - Small', type: 'Good', maxQuantity: 15 },
  { itemNumber: '64225', description: 'AirFit™ N30 Mask - Large', type: 'Good', maxQuantity: 7 },
  { itemNumber: '64102', description: 'AirFit™ F30 Complete Mask - Small', type: 'Good', maxQuantity: 9 },
  { itemNumber: '64103', description: 'AirFit™ F30 Complete Mask - Large', type: 'Good', maxQuantity: 6 },
  { itemNumber: '64301', description: 'Service Consultation - Basic', type: 'Service Offering', maxQuantity: 3 },
  { itemNumber: '64302', description: 'Service Consultation - Advanced', type: 'Service Offering', maxQuantity: 2 },
];


export const buttonStyles = {
  discardBtn: {
    backgroundColor: '#fff',
    color: '#0D0A15',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#0D0A15',
    },
  },
  confirmBtn: {
    '&.MuiButton-contained': {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: '#0D0A15',
        color: '#FFF',
      },
    },
    backgroundColor: '#0D0A15',
    color: '#FFF',
    fontWeight: 600,
    fontSize: '16px',
    borderRadius: '100px',
    textTransform: 'none',
     border: '1px solid #0D0A15',
  },
};

export const rowsPerPagesOptions = [5, 10, 20, 30, 50, 75, 100];

export const DVA_ORDER_TYPE = 'AU_DVA';